import type { MailboxInfo } from "owa-client-types";
import { action } from "satcheljs";

export interface Move_To_FolderActionMessage {
    folderName: string;
    mailboxInfo: MailboxInfo;
    hostItemIndex: string;
    targetWindow: Window;
}
const moveToFolder: (folderName: string, mailboxInfo: MailboxInfo, hostItemIndex: string, targetWindow: Window) => Move_To_FolderActionMessage = action("Move_To_Folder", (folderName: string, mailboxInfo: MailboxInfo, hostItemIndex: string, targetWindow: Window): Move_To_FolderActionMessage => ({
    folderName,
    mailboxInfo,
    hostItemIndex,
    targetWindow,
}));

export default moveToFolder;
